import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import {
    getConversionOppVendorList, getTerminatedVPOpportunitiesDetails,
    getTerminatedVPOpportunities, getTerminatedVPNamesForMember, saveProductFeedback,
    getMemberConversionMonthsFilter, tabTracking
} from '../../../actions';
import './TerminatedVPOpportunities.css';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Filters from '../../../components/Filters.jsx';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
// import { Dropdown,checkbox} from 'react-bootstrap';
import ReactExport from "react-export-excel";
import _find from 'lodash/find';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter, dynamicDateFilters1, monthName, monthName1, jsonToParam, paramsToJSON, paramsToJSON1 } from '../../../helper';
import { matLoader } from '../../../components/Loader';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import { Checkbox } from 'semantic-ui-react'

class Conversionopp extends React.Component {
    state = {

        VNames:[],
        selectedVendor: "All Suppliers",
        selectedFilter: "YTD",
        buttonOptions: ["MTH", "YTD", "QTR"],
        showQuarter: false,
        dataval: [],
        items: [],
        selectedYear: new Date().getFullYear(),
        selectedItem: new Date().getMonth(),
        listOfVendorPartners: [
            {
                key: 1,
                text: 'Supplier Partner 1',
                value: 'Supplier Partner 1',
            },
            {
                key: 2,
                text: 'Supplier Partner 2',
                value: 'Supplier Partner 2',
            },
        ],
        terminatedVpOpportunity: [{
            terminatedVendorPartner: 'VP1',
            businessGroup: 'BH Category 1',
            purchases: 12345,
            productGroup: 'Product Group 1',
            vendor1: '',
            vendor2: 'VP 2',
            vendor3: 'VP 3',
            vendor4: 'VP 4'

        }],
        isLoading: true,
        disableVendorDropdown: true,
        params: {
            period: "YTD",
            ytd: "true",
            qtr: "false",
            mth: "false",
            year: 2022,
            month: 12,
            quarter: 1,
            buyingGroupId: 0,
            terminatedVendorId:'',
            source :'member',
            //terminatedVendorId: this.props.allvendorArrvalue,
            "memberId": this.props.memberIdForCorporate,
            "buyingGroupid": this.props.buyingGroupId,
            "dropDown": [],

        },
        
    }

    handleUserSelectedFilter(option) {
        let obj = {};

        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }

        let paramsValues = this.state.params;
        let paramsfinal = paramsToJSON1(paramsValues);
        let month = paramsfinal.month;
        if (month >= 1 && month <= 3) {
            paramsfinal.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            paramsfinal.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            paramsfinal.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            paramsfinal.quarter = 4
        }

        let params = jsonToParam(paramsfinal);
        this.setState({ selectedFilter: option, params: params }, () => {
            this.setFilter({ period: this.state.selectedFilter, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }
    componentWillMount() {

        console.log(this.state.params,"asdasdsad", this.state.params.year)
        let paramsValues = this.state.params;
        // let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsValues);

        console.log(params);
        this.setState({ params: params });

    }

    componentDidMount() {
        
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptions: ["YTD", "QTR"], selectedFilter: "YTD" });
        }
        Promise.all([
           // this.props.getConversionOppVendorListAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=7"),
            this.props.getMemberConversionMonthsFilterAPI(this.state.params),

        ]).then(data => {
            this.getOptions();
            this.getOptionsYear();
            this.getVendorList();
            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        })
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 5000);

    }
    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let obj = {};
        obj[event.name] = event.value;
        params.quarter = event.value;
        let quarter = params.quarter
        params = jsonToParam(params);
        this.setState({
            quarter: quarter,
            params: params
        })
        this.setState(obj, () => {
            this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
        });

    }
    getVendorList() {
        let params = this.state.params;
        params = paramsToJSON(params);
        let VNameObj = [];
        let allvendorArrvalue = [];

        this.props.getConversionOppVendorListAPI(params).then(res => {

            let vendorId = ''
            res.map((data, index) => {
                allvendorArrvalue.push(_get(data, 'vendorId', ''));
            })
            VNameObj = res.map((data, index) => {
                return {
                    label: data.vendorName,
                    value: data.vendorId
                }
            })

            VNameObj.unshift({ label: "All Suppliers", value: this.props.allvendorArrvalue });

    
        let selectedVendor1 = VNameObj[0];
        params.terminatedVendorId = selectedVendor1.value;
        params = jsonToParam(params)
        console.log(this.state.params,"this.state.params");
        this.setState({
            VNames: VNameObj,
            selectedVendor: selectedVendor1,
            params: params
        })
        this.props.getTerminatedVPOpportunitiesDetailsAPI(this.state.params)
        this.props.getTerminatedVPOpportunitiesAPI(this.state.params)
        //this.props.getConversionOppVendorListAPI({ memberId: this.props.memberIdForCorporate })
        this.props.getTerminatedVPNamesForMemberAPI(this.state.params)
    })
        
    }

    handleChangeOfDropdownYear(e) {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let month = ''
        params.year = e.value
        year = params.year
        let selectedYear = { label: year, value: year }
        // let memberId=params.memberId;
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
        }, this.getOptions, this.getVendorList)
        let allvendorArrvalue = [];

        let VNameObj = [];
        this.props.getConversionOppVendorListAPI(params).then(res => {

            let vendorId = ''
            res.map((data, index) => {
                allvendorArrvalue.push(_get(data, 'vendorId', ''));
            })
            VNameObj = res.map((data, index) => {
                return {
                    label: data.vendorName,
                    value: data.vendorId
                }
            })

            VNameObj.unshift({ label: "All Suppliers", value: this.props.allvendorArrvalue });
            let selectedVendor = VNameObj[0]
            params = paramsToJSON(params);
            params.terminatedVendorId = VNameObj[0].value;
            let terminatedVendorId = params.terminatedVendorId
            params.month = this.state.selectedItem.value;
            month = params.month
            if (month >= 1 && month <= 3) {
                params.quarter = 1
            }
            else if (month >= 4 && month <= 6) {
                params.quarter = 2
            }
            else if (month >= 7 && month <= 9) {
                params.quarter = 3
            }
            else if (month >= 10 && month <= 12) {
                params.quarter = 4
            }
            params = jsonToParam(params);
            this.setState({
                VNames: VNameObj,
                params: params,
                selectedYear: selectedYear,
                selectedVendor: selectedVendor,
                month: month
            })
            this.setState(e, () => {
                this.setFilter({ year: this.state.year,terminatedVendorId:terminatedVendorId, selectedYear: selectedYear });
            });

        })




        
        // let params = this.state.params;
        // params = paramsToJSON1(params);
        // let year = ''
        // params.year = e.value
        // year = params.year
        // let selectedYear = { label: year, value: year }

        // params = jsonToParam(params);
        // this.setState({
        //     params: params,
        //     selectedYear: selectedYear,
        // }, this.getOptions)

        // console.log(this.state.selectedYear);


    }
    getOptionsYear() {
        let params = this.state.params;
        params = paramsToJSON(params);
        let dataval = Object.keys(this.props.getMemberConversionMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
       
        console.log("selectedYear.value",selectedYear.value)
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });

        }
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            else if (selectedYear.value != 2023 && selectedYear.value != 2024){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
        }

        //add this new code
        else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }

        console.log(selectedYear.value,"selectedYear.value")
        params.year = selectedYear.value;
         params = jsonToParam(params);
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
             params: params ,
        }, ()=>{
            console.log('year after options func', this.state.selectedYear, this.state.params);
        })
    }
    getOptions() {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let items = []
        let dataval = Object.keys(this.props.getMemberConversionMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];
        if(localStorage.getItem('flag') == 11){
            items = this.props.getMemberConversionMonthsFilter[selectedYear1.value].map(itemval => {
                return {
                    label: monthName1(itemval),
                    value: itemval,
                }
    
            })
          }
          else{
            let months = this.props.getMemberConversionMonthsFilter[params.year];
            if(typeof months == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = months.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }
        }
        
        if (selectedYear1.value != 2021 && selectedYear1.value != 2022)
        {
        yearval.push({ label: 2021, value: 2021 });
        
        yearval.push({ label: 2022, value: 2022 });
        
        }
        else if (selectedYear1.value != 2022 && selectedYear1.value == 2021){
            yearval.push({ label: 2022, value: 2022 });
  
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        console.log(selectedItem.value,"selectedItem.value")
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })

        console.log(this.state.params,"this.state.params")

        // this.props.getTerminatedVPOpportunitiesDetailsAPI(this.state.params)
        // this.props.getTerminatedVPOpportunitiesAPI(this.state.params)
        // // this.props.getConversionOppVendorListAPI({ memberId: this.props.memberIdForCorporate })
        // this.props.getTerminatedVPNamesForMemberAPI(this.state.params)

    }

    renderButtonGroup() {

        return this.state.buttonOptions.map((option, index) => {
            return (
                <button style={{ height: '38px' }} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilter === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
    handleChangeOfDropdownMonth = (e) => {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month

        let selectedItem = { label: monthName1(month), value: month }

        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })


        this.props.getTerminatedVPOpportunitiesDetailsAPI(params)
        // this.props.getTerminatedVPOpportunitiesAPI(params)
        this.props.getConversionOppVendorListAPI({ memberId: this.props.memberIdForCorporate })
        this.props.getTerminatedVPNamesForMemberAPI(params)


    }
    setFilter = (filter) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";

            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {
            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";

            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            params.period = filter.period;
        }
        else if (filter.memberId != undefined) {
            params.memberId = filter.memberId;

        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            isLoading: true
        }, () => Promise.all([

            this.props.getTerminatedVPOpportunitiesDetailsAPI(this.state.params),
            this.props.getTerminatedVPOpportunitiesAPI(this.state.params),
            this.props.getConversionOppVendorListAPI({ memberId: this.props.memberIdForCorporate }),
            this.props.getTerminatedVPNamesForMemberAPI(this.state.params),

        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }

    handleClick = (e, value) => {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let selectedVendor = { label: e.label, value: e.value }
        let arr = [];
        let valstr = [e.value];
        
        if (valstr != "" && valstr != "undefined") {
            // let valueee = valstr.map((option, index) => {
            // let val = _find(value.options, ['value', option])
            arr.push(valstr)
            // })
            params.terminatedVendorId = arr
        }
        else {
            params.terminatedVendorId = "";

        }
        
        let items = [];
        items = this.props.getMemberConversionMonthsFilter[params.year].map(itemval => {
            return {
                label: monthName1(itemval),
                value: itemval,
            }

        })
        
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
       // params = jsonToParam(params);
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedVendor: selectedVendor,
        })
       // this.props.getMemberConversionMonthsFilterAPI(params);
        this.props.getTerminatedVPOpportunitiesDetailsAPI(params);
        this.props.getTerminatedVPOpportunitiesAPI(params);
        
        // ;
        // let params = this.state.params;
        // params = paramsToJSON(params);
        // let arr = [];
        // let valstr = [value.value];
        // if (valstr != "" && valstr != "undefined") {
        //     let valueee = valstr.map((option, index) => {
        //         let val = _find(value.options, ['value', option])
        //         arr.push(val.value)
        //     })
        //     params.terminatedVendorId = arr
        // }
        // else {
        //     params.terminatedVendorId = "";
        // }
        // params = jsonToParam(params);
        // this.setState({
        //     params: params, flag: true
        // });
        // this.props.getMemberConversionMonthsFilterAPI(params);
        // this.props.getTerminatedVPOpportunitiesDetailsAPI(params);
        // this.props.getTerminatedVPOpportunitiesAPI(params);
    }

    BusinessGroupUpperCase = (cell, rows) => {
        let tier = _get(rows, 'businessGroupName', "")
        let businessGroupName = tier;
        if (businessGroupName) {
            return <div className="businessGroupName" style={{ textTransform: 'capitalize' }}>{businessGroupName}</div>
        }
    }
    showPopUpForFavorableVp1 = (cell, row) => {
        if (_isEmpty(row.favorableVendor1Name)) {
            return (
                <div></div>
            )
        }
        return (
            <div onClick={(e) => this.showModalForFavorableVendor(1, row, row.favorableVendor1Id, row.favorableVendor1Name)} style={{ textTransform: 'uppercase' }}>{row.favorableVendor1Name} <i class="fas fa-comment-alt"></i></div>
        )
    };
    showPopUpForFavorableVp2 = (cell, row) => {
        if (_isEmpty(row.favorableVendor2Name)) {
            return (
                <div></div>
            )
        }
        return (
            <div onClick={(e) => this.showModalForFavorableVendor(2, row, row.favorableVendor2Id, row.favorableVendor2Name)} style={{ textTransform: 'uppercase' }} >{row.favorableVendor2Name} <i class="fas fa-comment-alt"></i></div>
        )
    };
    showPopUpForFavorableVp3 = (cell, row) => {
        if (_isEmpty(row.favorableVendor3Name)) {
            return (
                <div></div>
            )
        }
        return (
            <div onClick={(e) => this.showModalForFavorableVendor(3, row, row.favorableVendor3Id, row.favorableVendor3Name)} style={{ textTransform: 'uppercase' }}>{row.favorableVendor3Name} <i class="fas fa-comment-alt"></i></div>
        )
    };
    showPopUpForFavorableVp4 = (cell, row) => {
        if (_isEmpty(row.favorableVendor4Name)) {
            return (
                <div></div>
            )
        }
        return (
            <div onClick={(e) => this.showModalForFavorableVendor(4, row, row.favorableVendor4Id, row.favorableVendor4Name)} style={{ textTransform: 'uppercase' }}>{row.favorableVendor4Name} <i class="fas fa-comment-alt"></i></div>
        )
    };
    showPopUpForFavorableVp5 = (cell, row) => {
        if (_isEmpty(row.favorableVendor5Name)) {
            return (
                <div></div>
            )
        }
        return (
            <div onClick={(e) => this.showModalForFavorableVendor(5, row, row.favorableVendor5Id, row.favorableVendor5Name)} style={{ textTransform: 'uppercase' }}>{row.favorableVendor5Name} <i class="fas fa-comment-alt"></i></div>
        )
    };
    // showModalForFavorableVendor = (num, row, vpSelected) => {
    //     this.setState({ numberOfFavorableVp: num, selectedCategory: row.leavingVendorName, selectedFavorableVp: vpSelected, showPopUpForFavorableVp: true })
    // }

    showModalForFavorableVendor = (num, row, vendorId, vpSelected) => {
        // 
        this.setState({
            numberOfFavorableVp: num, selectedCategoryId: row.businessGroupId, selectedCategory: row.businessGroupName,
            selectedFavorableVpId: vendorId, selectedFavorableVp: vpSelected,
            productGroupName: row.productGroupName, productGroupId: row.productGroupId,
            showPopUpForFavorableVp: true
        })
    }

    closeFavorableVendorModal = () => {
        this.setState({ showPopUpForFavorableVp: false });
    }
    handleOnChange(event) {
        this.setState({
            textareaValue: event.target.value
        })
        this.refs.comment.value = '';
    }
    handleClickVendor = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedFavorableVendorId: encodeURIComponent(arr), suggestedFavorableVendorName: encodeURIComponent(arr1), selectFavorableVpErrorMessage: '' })

    }
    sendFeedbackForFavorableVendor() {
        let selections = {
            productId: this.state.productGroupId,
            productDesc: this.state.productGroupName,
            favorableVendorId: this.state.selectedFavorableVpId,
            favorableVendorName: this.state.selectedFavorableVp,
            feedbackComment: this.state.textareaValue,
            favorableVendorWrong: this.state.feedbackToggleForFavorableVp,
            suggestedFavorableVendorId: this.state.suggestedFavorableVendorId,
            suggestedFavorableVendorName: this.state.suggestedFavorableVendorName,
            categoryId: this.state.selectedCategoryId,
            categoryName: this.state.selectedCategory,
        }

        if (!this.state.suggestedFavorableVendorName) {
            this.setState({ selectFavorableVpErrorMessage: 'Please select a Supplier' }, () => {
            });
        } else {
            this.setState({ showPopUpForFavorableVp: false, textareaValue: '', feedbackComment: '', disableVendorDropdown: true, suggestedFavorableVendorName: '', selectFavorableVpErrorMessage: '' }, () => {
                this.props.saveProductFeedbackAPI(selections, (res) => {
                    toast(res.data.text);

                });

            });
        }
    }

    render() {
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        const { terminatedVpOpportunityDetails, terminatedVpOpportunity, vendorNames } = this.props;

        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    //    console.log(this.state.selectedVendor);
        console.log(this.state.VNames,'vnames');
        let params = this.state.params;
        // console.log('year', this.state.params);
        params = paramsToJSON(params);
        return (
            <div className="Dashboard">
                <ToastContainer style={{ zIndex: '9999' }} />
                <nav className="userInfo Filters navbar">
                    <span className="navbar-brand nav-head">Conversion Opportunity</span>
                    <div className="export-button-wrapper">
                        {/* <Dropdown style={{ height: '38px', marginTop: '9px' }} clearable onChange={(e, value) => this.handleClick(e, value)}
                            placeholder='Select Leaving Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                         <Select id="vendorvalue" style={{width:'400px'}} onChange={(e) => this.handleClick(e)}
                            value={this.state.selectedVendor}
                            options={this.state.VNames} />
                        <ul className="navbar-nav flexRowForFilters" >
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style={{ height: '38px', width: '80px' }} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={params.quarter == 4 ? true : false} >QTR4</option>

                                    </select>

                                </li>
                                :
                                <li className="nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }
                        </ul>
                        <ExcelFile element={<button className="btn btn-primary" style={{ height: '38px' }}>Export</button>}>
                            <ExcelSheet data={this.props.terminatedVpOpportunityDetails} name="VP Opportunity Details">
                                <ExcelColumn label="SUPPLIER NAME" value="leavingVendorName" />
                                <ExcelColumn label="PO COUNT" value="poCount" />
                                <ExcelColumn label="VOLUME" value="purchases" />
                                <ExcelColumn label="AVERAGE VOLUME/PO" value="avgPurchases" />
                            </ExcelSheet>
                            <ExcelSheet data={this.props.terminatedVpOpportunity} name="Terminated VP Opportunity">
                                <ExcelColumn label="SUPPLIER NAME" value="leavingVendorName" />
                                <ExcelColumn label="CATEGORY GROUP" value="businessGroupName" />
                                <ExcelColumn label="PRODUCT GROUP" value="productGroupName" />
                                <ExcelColumn label="VOLUME" value="purchases" />
                                <ExcelColumn label="SUPPLIER  1" value="favorableVendor1Name" />
                                <ExcelColumn label="SUPPLIER  2" value="favorableVendor2Name" />
                                <ExcelColumn label="SUPPLIER  3" value="favorableVendor3Name" />
                                <ExcelColumn label="SUPPLIER  4" value="favorableVendor4Name" />
                                <ExcelColumn label="SUPPLIER  5" value="favorableVendor5Name" />
                            </ExcelSheet>
                        </ExcelFile>
                    </div>
                </nav>
                {this.state.isLoading ? matLoader() : <div>

                    <div class="col-12" style={{ paddingBottom: "5px", paddingTop: "", marginLeft: "", marginTop: "" }}>
                        {/* <div className="col-12"> */}
                        <div className="card-deck">
                            <div className="card shadow-sm mb-3">

                                <div className="card-header">
                                    Conversion Opportunity PO Details
                        </div>
                                <div className="card-body" style={{ maxHeight: "200" }}>
                                    <BootstrapTable height='200' data={terminatedVpOpportunityDetails} striped hover version="4">
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='poCount'>Po Count</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='purchases'>Purchases</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='avgPurchases'>Average Purchases/PO</TableHeaderColumn>
                                    </BootstrapTable>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                    <div className="col-12" style={{ paddingBottom: "12px", paddingTop: "0", marginLeft: "" }}>
                        {/* <div className="col-12"> */}
                        <div className="card-deck">
                            <div className="card shadow-sm mb-3">

                                <div className="card-header">
                                    Conversion Opportunity
                        </div>

                                <div className="card-body" style={{ maxHeight: "400" }}>
                                    <BootstrapTable height='400' data={this.props.terminatedVpOpportunity} striped hover version="4">
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} isKey dataField='leavingVendorName'>Leaving Supplier</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} dataFormat={this.BusinessGroupUpperCase} dataField='businessGroupName'>Business Group</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='productGroupId'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='favorableVendor1Id'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='favorableVendor2Id'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='favorableVendor3Id'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='favorableVendor4Id'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} hidden dataField='favorableVendor5Id'></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150px" dataSort={true} dataField='productGroupName'>Product Group</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100px" dataFormat={PriceFormatter} dataSort={true} dataField='purchases'>Purchases</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="160px" dataSort={true} dataFormat={this.showPopUpForFavorableVp1} dataField='favorableVendor1Name'>Favorable Supplier 1</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="160px" dataSort={true} dataFormat={this.showPopUpForFavorableVp2} dataField='favorableVendor2Name'>Favorble Supplier 2</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="160px" dataSort={true} dataFormat={this.showPopUpForFavorableVp3} dataField='favorableVendor3Name'>Favorable Supplier 3</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="160px" dataSort={true} dataFormat={this.showPopUpForFavorableVp4} dataField='favorableVendor4Name'>Favorable Supplier 4</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="160px" dataSort={true} dataFormat={this.showPopUpForFavorableVp5} dataField='favorableVendor5Name'>Favorable Supplier 5</TableHeaderColumn>
                                        {/* <TableHeaderColumn width="200px" dataSort={true} dataField='vendor5'>SUPPLIER PARTNER 5</TableHeaderColumn> */}
                                    </BootstrapTable>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    {this.state.showPopUpForFavorableVp ?
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" >Favorable Supplier Feedback</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeFavorableVendorModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        <div >
                                            <form>
                                                <div className="form-group feedbackToggle">
                                                    <label >Is {this.state.selectedFavorableVp} Favorable Supplier wrong for <b>{this.state.productGroupName}</b>? </label>
                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableVendorDropdown: false, selectFavorableVpErrorMessage: '' });
                                                        } else {
                                                            this.setState({ disableVendorDropdown: true, selectFavorableVpErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForFavorableVp: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select Favorable Supplier '
                                                        disabled={this.state.disableVendorDropdown}
                                                        fluid
                                                        search
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.vendorNamesList1}
                                                        onChange={(e, value) => this.handleClickVendor(e, value)}
                                                    />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <label>Comments</label>
                                                    <textarea ref="comment" rows={4} cols={30} value={this.state.textareaValue}
                                                        onChange={(e, value) => this.handleOnChange(e, value)} />

                                                </div>

                                            </form>
                                            <span className="errorText">{this.state.selectFavorableVpErrorMessage}</span>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" onClick={(e) => { this.sendFeedbackForFavorableVendor() }} className="btn btn-primary">Submit</button>
                                        <button type="button" onClick={(e) => { this.closeFavorableVendorModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }
                </div>}
            </div>


        )

    }
}
function mapStateToProps(state) {
    let allvendor = _get(state, 'member.getConversionOppVendorList', []);
    
    var allvendorArr = [];
    if (!_isEmpty(allvendor)) {
        allvendor.map((data, index) => {
            allvendorArr.push(_get(data, 'vendorId', ''));
        })
        
    }
    else {
        allvendorArr.push([]);
    }
    let vendorNames = [];
    let vendorNameprops = _get(state, 'member.getConversionOppVendorList', []);
    vendorNameprops && vendorNameprops.map((vname, index) => {
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId
        }
        vendorNames.push(vendorNameObj)
    })
    
    
    let vendorNames1 = [];
    let vendorNameprops1 = _get(state, 'member.getTerminatedVPNamesForMember', []);
    //;
    vendorNameprops1 && vendorNameprops1.map((vname, index) => {
        let vendorNameObj1 = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId
        }
        vendorNames1.push(vendorNameObj1)
    })
    return {
        allvendorArrvalue: allvendorArr,
        vendorNamesList: vendorNames,
        vendorNamesList1: vendorNames1,
        terminatedVpOpportunityDetails: _get(state, 'member.getTerminatedVpOpportunitiesTerminatedVpOpportunityDetails', []),
        terminatedVpOpportunity: _get(state, 'member.getTerminatedVpOpportunitiesTerminatedVpOpportunity', []),
        getMemberConversionMonthsFilter: _get(state, 'member.getMemberConversionMonthsFilter', []),
        getConversionOppVendorList: _get(state, 'member.getConversionOppVendorList', []),
        isFetching: _get(state, 'member.isFetching', true),
        memberIdForCorporate: _get(sessionStorage, 'imark-memberId', ''),
        buyingGroupId: _get(sessionStorage, 'imark-buyingGroupId', ''),
        tabTracking: _get(state, 'corporate.tabTracking', []),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTerminatedVPOpportunitiesDetailsAPI: getTerminatedVPOpportunitiesDetails,
        getTerminatedVPOpportunitiesAPI: getTerminatedVPOpportunities,
        getConversionOppVendorListAPI: getConversionOppVendorList,
        getTerminatedVPNamesForMemberAPI: getTerminatedVPNamesForMember,
        saveProductFeedbackAPI: saveProductFeedback,
        getMemberConversionMonthsFilterAPI: getMemberConversionMonthsFilter,
        tabTrackingAPI: tabTracking,
    },
        dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversionopp);
